import { combineReducers } from 'redux';
import { handleActions, combineActions } from 'redux-actions';
import * as actionTypes from './constants';

export const isLoadingPlants = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_SKILL_PLANTS_SUCCESS,
      actionTypes.FETCH_SKILL_PLANTS_FAILURE,
    )]: () => false,
    [combineActions(
      actionTypes.FETCH_SKILL_PLANTS_REQUEST,
    )]: () => true,
  },
  false,
);

export const plants = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_SKILL_PLANTS_REQUEST,
      actionTypes.FETCH_SKILL_PLANTS_FAILURE,
    )]: () => [],
    [actionTypes.FETCH_SKILL_PLANTS_SUCCESS]: (state, { payload }) => payload.items,
  },
  [],
);

export const isLoadingSkills = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_SKILLS_SUCCESS,
      actionTypes.FETCH_SKILLS_FAILURE,
    )]: () => false,
    [combineActions(
      actionTypes.FETCH_SKILLS_REQUEST,
    )]: () => true,
  },
  false,
);

export const isLoadingSkillsNext = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_SKILLS_NEXT_SUCCESS,
      actionTypes.FETCH_SKILLS_NEXT_FAILURE,
    )]: () => false,
    [combineActions(
      actionTypes.FETCH_SKILLS_NEXT_REQUEST,
    )]: () => true,
  },
  false,
);

export const isUpdatingSkill = handleActions(
  {
    [combineActions(
      actionTypes.UPDATE_SKILL_SUCCESS,
      actionTypes.UPDATE_SKILL_FAILURE,
    )]: () => false,
    [combineActions(
      actionTypes.UPDATE_SKILL_REQUEST,
    )]: () => true,
  },
  false,
);

export const skills = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_SKILLS_REQUEST,
      actionTypes.FETCH_SKILLS_FAILURE,
    )]: () => ({}),
    [actionTypes.FETCH_SKILLS_SUCCESS]: (state, { payload }) => payload,
    [actionTypes.UPDATE_SKILL_SUCCESS]: (state, { payload }) => ({
      ...state,
      data: state?.data?.map(s => s.id === payload.id ? payload : s),
    }),
    [actionTypes.UPDATE_SKILL_FAILURE]: (state, { payload }) => ({
      ...state,
      data: state?.data?.map((s) => {
        if (s.id === payload.id) {
          return {
            ...s,
            assignedSkillIds: payload.originalSkills,
          };
        }
        return s;
      }),
    }),
    [actionTypes.FETCH_SKILLS_NEXT_SUCCESS]: (state, { payload }) => ({
      ...payload,
      data: [
        ...state?.data,
        ...payload?.data,
      ],
    }),
  },
  {},
);

export const skillsError = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.FETCH_SKILLS_REQUEST,
      actionTypes.FETCH_SKILLS_SUCCESS,
      actionTypes.FETCH_SKILLS_NEXT_REQUEST,
      actionTypes.FETCH_SKILLS_NEXT_SUCCESS,
      actionTypes.UPDATE_SKILL_REQUEST,
      actionTypes.UPDATE_SKILL_SUCCESS,
    )]: () => ({}),
    [combineActions(
      actionTypes.FETCH_SKILLS_FAILURE,
      actionTypes.FETCH_SKILLS_NEXT_FAILURE,
      actionTypes.UPDATE_SKILL_FAILURE,
    )]: (state, { payload }) => payload.error,
  },
  {},
);

export const isLoadingWizardData = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_WIZARD_DATA_FAILURE,
      actionTypes.FETCH_WIZARD_DATA_SUCCESS,
    )]: () => false,
    [combineActions(
      actionTypes.FETCH_WIZARD_DATA_REQUEST,
    )]: () => true,
  },
  false,
);

export const wizardData = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.FETCH_WIZARD_DATA_REQUEST,
      actionTypes.FETCH_WIZARD_DATA_FAILURE,
    )]: () => ({}),
    [combineActions(
      actionTypes.FETCH_WIZARD_DATA_SUCCESS,
    )]: (state, { payload }) => payload,
  },
  {},
);

export const isLoadingSkill = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_SKILL_FAILURE,
      actionTypes.FETCH_SKILL_SUCCESS,
    )]: () => false,
    [combineActions(
      actionTypes.FETCH_SKILL_REQUEST,
    )]: () => true,
  },
  false,
);

export const skill = handleActions(
  {
    [combineActions(
      actionTypes.RESET_SKILL,
      actionTypes.FETCH_SKILL_REQUEST,
      actionTypes.FETCH_SKILL_FAILURE,
    )]: () => ({}),
    [combineActions(
      actionTypes.FETCH_SKILL_SUCCESS,
    )]: (state, { payload }) => payload || {},
  },
  {},
);

export const isLoadingMasterData = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_MASTER_DATA_SUCCESS,
      actionTypes.FETCH_MASTER_DATA_FAILURE,
    )]: () => false,
    [combineActions(
      actionTypes.FETCH_MASTER_DATA_REQUEST,
    )]: () => true,
  },
  false,
);

export const isUpdatingMasterData = handleActions(
  {
    [combineActions(
      actionTypes.UPDATE_MASTER_DATA_SUCCESS,
      actionTypes.UPDATE_MASTER_DATA_FAILURE,
      actionTypes.DELETE_MASTER_DATA_SUCCESS,
      actionTypes.DELETE_MASTER_DATA_FAILURE,
      actionTypes.ADD_MASTER_DATA_SUCCESS,
      actionTypes.ADD_MASTER_DATA_FAILURE,
    )]: () => false,
    [combineActions(
      actionTypes.UPDATE_MASTER_DATA_REQUEST,
      actionTypes.DELETE_MASTER_DATA_REQUEST,
      actionTypes.ADD_MASTER_DATA_REQUEST,
    )]: () => true,
  },
  false,
);

export const updateMasterDataSuccess = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.UPDATE_MASTER_DATA_SUCCESS,
      actionTypes.UPDATE_MASTER_DATA_REQUEST,
      actionTypes.ADD_MASTER_DATA_SUCCESS,
      actionTypes.ADD_MASTER_DATA_REQUEST,
      actionTypes.RESET_SKILL,
    )]: () => false,
    [combineActions(
      actionTypes.UPDATE_MASTER_DATA_SUCCESS,
      actionTypes.ADD_MASTER_DATA_SUCCESS,
    )]: () => true,
  },
  false,
);

export const masterData = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_MASTER_DATA_REQUEST,
      actionTypes.FETCH_MASTER_DATA_FAILURE,
    )]: () => [],
    [actionTypes.FETCH_MASTER_DATA_SUCCESS]: (state, { payload }) => payload.skills?.map(s => ({
      ...s,
      scopeDescription: s?.scopeDescription || s?.scope,
    })),
    [actionTypes.DELETE_MASTER_DATA_SUCCESS]: (state, { payload }) =>
      (state || [])?.filter(d => d.id !== payload.id),
    [actionTypes.UPDATE_MASTER_DATA_SUCCESS]: (state, { payload }) => state?.map((d) => {
      if (d.id === payload.id) {
        return {
          ...payload,
          scopeDescription: payload?.scopeDescription || payload?.scope,
        };
      }
      return {
        ...d,
        scopeDescription: d?.scopeDescription || d?.scope,
      };
    }),
    [actionTypes.ADD_MASTER_DATA_SUCCESS]: (state, { payload }) => {
      const newSkills = [...state || [], payload];
      return newSkills?.map(s => ({
        ...s,
        scopeDescription: s?.scopeDescription || s?.scope,
      }));
    },
  },
  [],
);

export const totalMasterDataCount = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_MASTER_DATA_REQUEST,
      actionTypes.FETCH_MASTER_DATA_FAILURE,
    )]: () => 0,
    [actionTypes.FETCH_MASTER_DATA_SUCCESS]: (state, { payload }) => payload.totalCount,
    [actionTypes.DELETE_MASTER_DATA_SUCCESS]: state => state <= 0 ? 0 : state - 1,
    [actionTypes.ADD_MASTER_DATA_SUCCESS]: state => state + 1,
  },
  0,
);

export const masterDataError = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.FETCH_MASTER_DATA_REQUEST,
      actionTypes.FETCH_MASTER_DATA_SUCCESS,
      actionTypes.UPDATE_MASTER_DATA_SUCCESS,
      actionTypes.UPDATE_MASTER_DATA_REQUEST,
      actionTypes.DELETE_MASTER_DATA_SUCCESS,
      actionTypes.DELETE_MASTER_DATA_REQUEST,
      actionTypes.ADD_MASTER_DATA_SUCCESS,
      actionTypes.ADD_MASTER_DATA_REQUEST,
      actionTypes.FETCH_WIZARD_DATA_REQUEST,
      actionTypes.FETCH_WIZARD_DATA_SUCCESS,
      actionTypes.FETCH_SKILL_REQUEST,
      actionTypes.FETCH_SKILL_SUCCESS,
    )]: () => ({}),
    [combineActions(
      actionTypes.FETCH_MASTER_DATA_FAILURE,
      actionTypes.UPDATE_MASTER_DATA_FAILURE,
      actionTypes.DELETE_MASTER_DATA_FAILURE,
      actionTypes.ADD_MASTER_DATA_FAILURE,
      actionTypes.FETCH_WIZARD_DATA_FAILURE,
      actionTypes.FETCH_SKILL_FAILURE,
    )]: (state, { payload }) => payload.error,
  },
  {},
);

export default combineReducers({
  skills,
  isLoadingSkills,
  isLoadingSkillsNext,
  skillsError,
  masterData,
  isLoadingMasterData,
  masterDataError,
  isUpdatingSkill,
  isUpdatingMasterData,
  updateMasterDataSuccess,
  isLoadingWizardData,
  wizardData,
  isLoadingSkill,
  skill,
  totalMasterDataCount,
  isLoadingPlants,
  plants,
});
